const sidemenu = function( ) {

  let sidemenu = document.getElementById('side-menu');
  let hideTimeout = null;

  if(sidemenu && !sidemenu.classList.contains('sidemenu-initialized')) {
    sidemenu.classList.add('sidemenu-initialized');
    init();

  }



  function init() {
    console.log('init');

    let information = document.getElementById('block-ark-theme-views-block-verdieping-block-1');
    let sources = document.getElementById('block-ark-theme-knowledge');
    let news = document.getElementById('block-ark-theme-views-block-nieuws-block-1');
    let downloads = document.getElementById('downloads');
    let map = document.getElementById('block-ark-theme-areamapblock-2');


    if(information || sources || downloads || news || map) {
      sidemenu.classList.add('is-visible');

      // Create mobile toggle button (outside the menu)
      let toggleBtn = document.createElement('div');
      toggleBtn.classList.add('sidemenu-toggle');
      toggleBtn.addEventListener('click', function(e) {
        e.preventDefault();
        sidemenu.classList.add('is-open');

        // Clear any existing timeout
        if(hideTimeout) {
          clearTimeout(hideTimeout);
        }

        // Auto-hide after 4 seconds
        hideTimeout = setTimeout(function() {
          sidemenu.classList.remove('is-open');
        }, 4000);
      });
      sidemenu.parentNode.insertBefore(toggleBtn, sidemenu);
    }

    adddItem(map, 'Kaart');
    adddItem(news, 'Nieuws');
    adddItem(information, 'Verdieping');
    adddItem(sources, 'Bronnen');

  }

  function adddItem(id, title){
    if(id && !id.classList.contains('sidemneu-processed')) {
      let div = document.createElement('div');
      div.classList.add('sidemenu-item');
      let a = document.createElement('a');
      a.classList.add('sidemenu-link');
      a.href = '#';
      a.innerHTML = title;
      div.addEventListener('click', function (e) {
        e.preventDefault();

        // Close the menu on mobile when clicking an item
        if(window.innerWidth < 1024) {
          sidemenu.classList.remove('is-open');
        }

        window.scrollTo({
          top: id.offsetTop - 30,
          behavior: 'smooth'
        });
      });
      a.addEventListener('click', function (e) {
        e.preventDefault();
      });
      div.appendChild(a);
      sidemenu.appendChild(div);
      id.classList.add('sidemneu-processed');
    }
  }




}




export default sidemenu;
